module.exports = __webpack_public_path__ + "img/aussie.75d98a14.png";